.content {
    box-sizing: border-box;
    padding: 16px;
}

.summary-icon {
    display: inline-flex;
    vertical-align: text-bottom;
    margin-right: 4px;
}

.message {
    height: fit-content;
    max-height: 70px;
    text-overflow: ellipsis;
    overflow: hidden;
    line-height: 17px;
    -webkit-line-clamp: 4;
    line-clamp: 4;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    text-align: left;
    align-items: flex-start;
}

.message-with-images {
    display: flex;
    gap: 8px;
    align-items: flex-start;
    max-height: 70px;
    overflow: hidden;
}

.image-preview-container {
    position: relative;
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 4px;
    overflow: hidden;
    background-color: var(--grey-xlt);
}

.image-preview {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.image-count-badge {
    position: absolute;
    top: 2px;
    right: 2px;
    background-color: rgba(0, 0, 0, 0.7);
    color: white;
    font-size: 10px;
    padding: 2px 4px;
    border-radius: 8px;
    line-height: 1;
}

.message-text {
    flex: 1;
    height: fit-content;
    max-height: 40px;
    text-overflow: ellipsis;
    overflow: hidden;
    line-height: 17px;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    text-align: left;
}
